import { type WebV1SurveysCloseCreateData } from '@credit-web/services/product-journey-girar'
import { type TransformTypesToCamelCase } from '@credit-web/services/types'
import camelcaseKeys from 'camelcase-keys'

/**
 * POST:/api/web/v1/surveys/{surveyKey}/close
 */
export const webV1SurveysCloseCreate: WebV1SurveysCloseCreateData = {
  content: {
    survey_id: 'dc661a74-76d9-4679-a948-15d63b2cc86e',
    survey_key: 'building_bff_disappointment_survey',
    interaction_id: 'jrhsptpv34n88gw7aftbugxga'
  },
  trace_key: 'jrhwqzqjwjb31476sr3cr92sn',
  is_valid: true
}

export const webV1SurveysCloseCreateTransformed = () =>
  camelcaseKeys(webV1SurveysCloseCreate, {
    deep: true
  }) as TransformTypesToCamelCase<WebV1SurveysCloseCreateData>
